import axios from 'axios';

export const getInfo = async _ => {
    const uri = `/v1/app`
    return axios.get(uri)
        .then(result => {
            console.log(result);
            const response = result.data;
            return response.data;
        })
}